import DreamMachine from './DreamMachine.jsx'
import '../styles/dream-machine.css'

export default function Projects() {
  return (
    <div className="mnd-section-container component">
      <div className="gallery-mnd-mnd-e" id="projectContainer">
        <div className="container">
          <div>
            <h3>Current projects</h3>
            <div className="col-sm-12 row">
              <div className="col-sm-12">
                <DreamMachine />
              </div>
              <div className="col-sm-12">
                <h2 className="h-title top-30">The Equation Generator</h2>
                <p>
                  <i>Final release.</i>
                </p>
                <br />
                <p>
                  Tiny web tool for stirring up some math magic! Dive into the equation universe with this fun app
                  that whips up random quadratic and higher-grade functions, unveiling their secret solutions.
                  <br />
                  Choose the equation degree and set the max coefficient value
                  to let the algorithm work its quirky algorithmic wonders. Brace yourself for an extensive list of
                  equation examples that'll make your brain do the cha-cha!
                  <br />
                  Get ready to flex those math muscles and let the randomness roll. Who said equations can't be a
                  blast? 🚀 🧮 #MathMagic #EquationExplorer
                </p>
                <div className="mandril_but">
                  <ul>
                    <li>
                      <a
                        className="book button-isi zoomIn animated"
                        data-wow-delay=".5s"
                        href="/equations"
                        target="_blank"
                      >
                        Try it out!
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div className="clearfix"></div>
            <div className="top-30">
              <h3>Public projects</h3>
              <div className="col-sm-12 project-line">
                <div className="col-sm-12 col-md-6 project-card">
                  <h2 className="h-title center">Molecular Data</h2>
                  <p style={{ color: '#e04530' }}>Public API.</p>
                  <p>
                    Molecular Data is an open API that provides quantum chemical calculations, molecular mechanics,
                    and dynamics data for a large amount of molecules, including molecular orbital diagrams and
                    representations.
                  </p>
                  <p>
                    Quantum data is obtained with <i>Ab Initio</i> calculations rather than <i>semi-empirical</i>{' '}
                    models to obtain substantially accurate results.
                  </p>
                  <br />
                  <p>Auth: No</p>
                  <p>HTTPS: Yes</p>
                  <p>CORS: Yes</p>
                  <p>Endpoint: https://api.mandrilsoft.com</p>
                  <div className="mandril_but">
                    <ul>
                      <li>
                        <a
                          className="book button-isi zoomIn animated"
                          data-wow-delay=".5s"
                          href="https://api.mandrilsoft.com"
                        >
                          Documentation
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
                <div className="col-sm-12 col-md-6 project-card">
                  <h2 className="h-title center">NPM library</h2>
                  <p>Final release.</p>
                  <p style={{ color: '#e04530' }}>react-simple-scrolldown.</p>
                  <p>Open source NPM package.</p>
                  <br />
                  <p>
                    There are some packages already existing in NPM to achieve scroll animations in ReactJS, but they
                    are massive and sometimes difficult to work with depending on the architecture of your
                    application.
                  </p>
                  <p>
                    React-simple-scroll is a very lightweight component that does not need to receive any props.
                  </p>
                  <p>
                    To use it, just call the scrollDown() function on an onClick event of the source element and make
                    sure the id of the source is the same as the class of the target element, simple as that.
                  </p>
                  <p className="git">
                    <a href="https://github.com/piyiyo/react-simple-scroll">
                      <i className="fab fa-github"></i> Github project
                    </a>
                  </p>
                </div>
              </div>
              <div className="clearfix"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
